import { render, staticRenderFns } from "./Events2.vue?vue&type=template&id=20321d9d"
import script from "./Events2.vue?vue&type=script&lang=ts"
export * from "./Events2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports